import { FolderKanban } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogClose } from '../ui/dialog';
import { PROJECT_ICONS, PROJECT_COLORS } from '../sidebar/constants';

const CreateProjectDialog = ({
  open,
  onOpenChange,
  workspaceName,
  projectName,
  setProjectName,
  projectColor,
  setProjectColor,
  projectIcon,
  setProjectIcon,
  onSubmit,
  loading
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md dark:bg-slate-800 dark:border-slate-700">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 dark:text-gray-100">
            <FolderKanban className="w-5 h-5 text-[#4A9CC7]" />
            New Project in {workspaceName}
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <Label htmlFor="project-name" className="dark:text-gray-300">Project Name</Label>
            <Input
              id="project-name"
              value={projectName}
              onChange={(e) => setProjectName(e.target.value)}
              placeholder="My Project"
              data-testid="project-name-input"
              onKeyDown={(e) => e.key === 'Enter' && onSubmit()}
              className="dark:bg-slate-900 dark:border-slate-600"
            />
          </div>
          <div className="space-y-2">
            <Label className="dark:text-gray-300">Icon</Label>
            <div className="flex gap-2 flex-wrap">
              {PROJECT_ICONS.map(({ id, icon: Icon }) => (
                <button
                  key={id}
                  onClick={() => setProjectIcon(id)}
                  className={`w-8 h-8 rounded-lg flex items-center justify-center transition-all ${
                    projectIcon === id 
                      ? 'bg-[#4A9CC7] text-white ring-2 ring-offset-2 ring-[#4A9CC7] dark:ring-offset-slate-800' 
                      : 'bg-gray-100 dark:bg-slate-700 text-gray-600 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-slate-600'
                  }`}
                >
                  <Icon className="w-4 h-4" />
                </button>
              ))}
            </div>
          </div>
          <div className="space-y-2">
            <Label className="dark:text-gray-300">Color</Label>
            <div className="flex gap-2 flex-wrap">
              {PROJECT_COLORS.map(color => (
                <button
                  key={color}
                  onClick={() => setProjectColor(color)}
                  className={`w-8 h-8 rounded-lg transition-all ${
                    projectColor === color ? 'ring-2 ring-offset-2 ring-gray-400 dark:ring-offset-slate-800 scale-110' : 'hover:scale-105'
                  }`}
                  style={{ backgroundColor: color }}
                />
              ))}
            </div>
          </div>
        </div>
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="outline" className="dark:border-slate-600 dark:text-gray-300">Cancel</Button>
          </DialogClose>
          <Button 
            onClick={onSubmit}
            disabled={loading || !projectName.trim()}
            className="bg-[#4A9CC7] hover:bg-[#3d8ab5]"
            data-testid="create-project-btn"
          >
            {loading ? 'Creating...' : 'Create Project'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default CreateProjectDialog;
